
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M118 101.33A14.33 14.33 0 01111.31 89V52.89a34.31 34.31 0 00-30.66-34.11v-.5a5.68 5.68 0 00-5.18-5.77A5.46 5.46 0 0069.71 18v.88a34.3 34.3 0 00-30.18 34V89a14.4 14.4 0 01-8.3 13.25l-.17.07a10.61 10.61 0 00-6.61 9.68h101.1v-.47a10.53 10.53 0 00-6.14-9.46c-.48-.22-.94-.47-1.41-.74zM64.43 125.82v.73a11 11 0 1021.9 0v-.73z"}})])
          )
        }
      }
    